export const getBSWheatPastaPackage = newProduct => {
  const newBSWheatPastaPackage = {
    UPC: newProduct.UPC,
    WholeWheatFlour: newProduct.WholeWheatFlour,
    PastaShape: newProduct.PastaShape,
    Size: newProduct.Size,
  }
  return newBSWheatPastaPackage
}

export const updateBSWheatPastaPackage = newProduct => {
  const newBSWheatPastaPackage = {
    UPC: newProduct.UPC,
    WholeWheatFlour: newProduct.WholeWheatFlour,
    PastaShape: newProduct.PastaShape,
    Size: newProduct.Size,
  }
  return newBSWheatPastaPackage
}
